import React from 'react';

export const DesignSystemIcon = ({ children, className = 'h-5 w-5', strokeWidth = '1.75' }) => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth={strokeWidth}
    strokeLinecap='round'
    strokeLinejoin='round'
    className={className}
  >
    {children}
  </svg>
);

export const ActivityIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='M22 12h-4l-3 8L9 4l-3 8H2' />
  </DesignSystemIcon>
);
export const AlertCircleIcon = (props) => (
  <DesignSystemIcon {...props}>
    <circle cx='12' cy='12' r='10' />
    <path d='M12 8v4' />
    <path d='M12 16h.01' />
  </DesignSystemIcon>
);
export const AwardIcon = (props) => (
  <DesignSystemIcon {...props}>
    <circle cx='12' cy='8' r='6' />
    <path d='M15.5 13.2 17 22l-5-3-5 3 1.5-8.8' />
  </DesignSystemIcon>
);
export const CalendarIcon = (props) => (
  <DesignSystemIcon {...props}>
    <rect x='3' y='4' width='18' height='18' rx='2' />
    <path d='M16 2v4' />
    <path d='M8 2v4' />
    <path d='M3 10h18' />
  </DesignSystemIcon>
);
export const CategoryIcon = (props) => (
  <DesignSystemIcon {...props}>
    <rect x='3' y='3' width='7' height='7' rx='1.5' />
    <rect x='14' y='3' width='7' height='7' rx='1.5' />
    <rect x='3' y='14' width='7' height='7' rx='1.5' />
    <rect x='14' y='14' width='7' height='7' rx='1.5' />
  </DesignSystemIcon>
);
export const CheckIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='M20 6 9 17l-5-5' />
  </DesignSystemIcon>
);
export const CopyIcon = (props) => (
  <DesignSystemIcon {...props}>
    <rect x='8' y='8' width='12' height='12' rx='2' />
    <path d='M16 8V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2' />
  </DesignSystemIcon>
);
export const ChevronDownIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='m6 9 6 6 6-6' />
  </DesignSystemIcon>
);
export const ChevronRightIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='m9 18 6-6-6-6' />
  </DesignSystemIcon>
);
export const ChevronUpIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='m18 15-6-6-6 6' />
  </DesignSystemIcon>
);
export const ClipboardListIcon = (props) => (
  <DesignSystemIcon {...props}>
    <rect x='8' y='2' width='8' height='4' rx='1' />
    <path d='M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2' />
    <path d='M9 12h6' />
    <path d='M9 16h6' />
  </DesignSystemIcon>
);
export const CreditCardIcon = (props) => (
  <DesignSystemIcon {...props}>
    <rect x='2' y='5' width='20' height='14' rx='2' />
    <path d='M2 10h20' />
  </DesignSystemIcon>
);
export const FileTextIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z' />
    <path d='M14 2v6h6' />
    <path d='M16 13H8' />
    <path d='M16 17H8' />
    <path d='M10 9H8' />
  </DesignSystemIcon>
);
export const HeartPulseIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='M20.8 5.6a5.4 5.4 0 0 0-7.6 0L12 6.8l-1.2-1.2a5.4 5.4 0 1 0-7.6 7.6L12 22l8.8-8.8a5.4 5.4 0 0 0 0-7.6Z' />
    <path d='M7 13h3l1.5-3 2 6 1.5-3h2' />
  </DesignSystemIcon>
);
export const HelpCircleIcon = (props) => (
  <DesignSystemIcon {...props}>
    <circle cx='12' cy='12' r='10' />
    <path d='M9.1 9a3 3 0 1 1 5.2 2c-.9.9-1.8 1.4-2.3 2.4' />
    <path d='M12 17h.01' />
  </DesignSystemIcon>
);
export const MapPinIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='M20 10c0 5-8 12-8 12S4 15 4 10a8 8 0 1 1 16 0Z' />
    <circle cx='12' cy='10' r='3' />
  </DesignSystemIcon>
);
export const MoreVerticalIcon = (props) => (
  <DesignSystemIcon {...props}>
    <circle cx='12' cy='12' r='1' />
    <circle cx='12' cy='5' r='1' />
    <circle cx='12' cy='19' r='1' />
  </DesignSystemIcon>
);
export const PillIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='M10 21 3 14a5 5 0 0 1 7-7l7 7a5 5 0 0 1-7 7Z' />
    <path d='m8 9 7 7' />
  </DesignSystemIcon>
);
export const ReorderIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='M17 4 21 8l-4 4' />
    <path d='M3 11V9a1 1 0 0 1 1-1h17' />
    <path d='m7 20-4-4 4-4' />
    <path d='M21 13v2a1 1 0 0 1-1 1H3' />
  </DesignSystemIcon>
);
export const RotateCcwIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='M3 12a9 9 0 1 0 3-6.7L3 8' />
    <path d='M3 3v5h5' />
  </DesignSystemIcon>
);
export const SendIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='m22 2-7 20-4-9-9-4Z' />
    <path d='M22 2 11 13' />
  </DesignSystemIcon>
);
export const ShieldIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10' />
  </DesignSystemIcon>
);
export const StarIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='m12 2 3.1 6.3 6.9 1-5 4.9 1.2 6.8-6.2-3.3L5.8 21 7 14.2 2 9.3l6.9-1z' />
  </DesignSystemIcon>
);
export const StethoscopeIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='M4.8 2.3v5.4a4.2 4.2 0 0 0 8.4 0V2.3' />
    <path d='M8 15.5a5 5 0 0 0 10 0v-2.2' />
    <circle cx='18' cy='10' r='2' />
  </DesignSystemIcon>
);
export const ThumbsDownIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='M17 14V2' />
    <path d='M9 18.1 10 14H4.2a2 2 0 0 1-2-2.3l1.4-7A2 2 0 0 1 5.6 3H17' />
    <path d='M17 14h3a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2h-3' />
    <path d='M10 14v4.5A2.5 2.5 0 0 0 12.5 21L17 14' />
  </DesignSystemIcon>
);
export const ThumbsUpIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='M7 10v12' />
    <path d='M15 5.9 14 10h5.8a2 2 0 0 1 2 2.3l-1.4 7a2 2 0 0 1-2 1.7H7' />
    <path d='M7 10H4a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h3' />
    <path d='M14 10V5.5A2.5 2.5 0 0 0 11.5 3L7 10' />
  </DesignSystemIcon>
);
export const TrashIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='M3 6h18' />
    <path d='M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2' />
    <path d='M19 6l-1 14a2 2 0 0 1-2 2H8a2 2 0 0 1-2-2L5 6' />
    <path d='M10 11v6' />
    <path d='M14 11v6' />
  </DesignSystemIcon>
);
export const TruckIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='M10 17H5a2 2 0 0 1-2-2V6h11v11' />
    <path d='M14 9h4l3 4v2a2 2 0 0 1-2 2h-1' />
    <path d='M14 17h1' />
    <circle cx='7' cy='17' r='2' />
    <circle cx='17' cy='17' r='2' />
  </DesignSystemIcon>
);
export const UploadIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4' />
    <path d='m17 8-5-5-5 5' />
    <path d='M12 3v12' />
  </DesignSystemIcon>
);
export const UsersPlusIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2' />
    <circle cx='9' cy='7' r='4' />
    <path d='M19 8v6' />
    <path d='M22 11h-6' />
  </DesignSystemIcon>
);
export const XIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='M18 6 6 18' />
    <path d='m6 6 12 12' />
  </DesignSystemIcon>
);
export const ZapIcon = (props) => (
  <DesignSystemIcon {...props}>
    <path d='M13 2 3 14h9l-1 8 10-12h-9z' />
  </DesignSystemIcon>
);
